import { ButtonGroup, Col, Input, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { OptionOne, OptionTwo } from "../../../../Constant";

export const StaticCheckBoxButtonGroup = () => {
  return (
    <Col xl="4" md="6" sm="12">
        <ButtonGroup className="btn-option">
          <Btn color="primary">
            <div className="checkbox checkbox-primary">
              <Input id="check1" type="checkbox" />
              <Label htmlFor="check1">{OptionOne}</Label>
            </div>
          </Btn>
          <Btn color="primary">
            <div className="checkbox checkbox-primary">
              <Input id="check2" type="checkbox" />
              <Label htmlFor="check2">{OptionTwo}</Label>
            </div>
          </Btn>
        </ButtonGroup>
    </Col>
  );
};
